import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ToolUnavailableErrorComponent } from '@lti/app/app-error/tool-unavailable-error/tool-unavailable-error.component';
import {
	ActivityNotFoundErrorComponent
} from '@lti/app/app-error/activity-not-found-error/activity-not-found-error.component';
import {
	InvalidActivityTypeChangeErrorComponent
} from '@lti/app/app-error/invalid-activity-type-change-error/invalid-activity-type-change-error.component';
import {
	CourseLicenseExpiredErrorComponent
} from '@lti/app/app-error/course-license-expired-error/course-license-expired-error.component';
import {
	MissingDeploymentErrorComponent
} from '@lti/app/app-error/missing-deployment-error/missing-deployment-error.component';
import {
	MissingParametersErrorComponent
} from '@lti/app/app-error/missing-parameters-error/missing-parameters-error.component';
import { DeprecatedLaunchErrorComponent } from './deprecated-launch-error/deprecated-launch-error.component';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { DefaultErrorRendererComponent } from '@lti/app/app-error/default-error-renderer/default-error-renderer.component';
import { AppErrorComponent } from '@lti/app/app-error/app-error.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		NgxZeroStateModule
	],
	declarations: [
		AppErrorComponent,
		ToolUnavailableErrorComponent,
		ActivityNotFoundErrorComponent,
		InvalidActivityTypeChangeErrorComponent,
		CourseLicenseExpiredErrorComponent,
		MissingDeploymentErrorComponent,
		MissingParametersErrorComponent,
		DeprecatedLaunchErrorComponent,
		DefaultErrorRendererComponent
	],
	exports: [
		AppErrorComponent,
		ToolUnavailableErrorComponent,
		ActivityNotFoundErrorComponent,
		InvalidActivityTypeChangeErrorComponent,
		CourseLicenseExpiredErrorComponent,
		MissingDeploymentErrorComponent,
		MissingParametersErrorComponent,
		DefaultErrorRendererComponent,
		DeprecatedLaunchErrorComponent
	]
})
export class AppErrorModule {}

